// Backlog 109 layer A: the "Still there?" prompt and the "you were set to
// Offline" notice. Rules: lib/awayGuard.js. Behaviour: hooks/useAwayGuard.js.
import React from 'react';
import { useAwayGuard } from '../hooks/useAwayGuard';
import { useStatusLog } from '../hooks/useStatusLog';
import { NOTICE_TEXT } from '../lib/awayGuard';

const strip = {
  display: 'flex', alignItems: 'center', gap: 16, padding: '12px 20px',
  background: 'rgba(240,180,90,0.14)', borderBottom: '1px solid rgba(240,180,90,0.45)',
  color: '#f3e3c2', fontSize: 14,
};
const button = {
  padding: '8px 14px', borderRadius: 8, border: '1px solid rgba(94,214,190,0.6)',
  background: 'rgba(94,214,190,0.14)', color: '#bff3e6', fontSize: 14, cursor: 'pointer',
};
const quiet = { ...button, border: '1px solid rgba(255,255,255,0.25)', background: 'transparent', color: '#d8dee4' };

export default function AwayGuard() {
  const { promptAt, secondsLeft, notice, imHere, goAvailable, dismissNotice } = useAwayGuard();
  // Row 200 step 3: log every confirmed status change (always mounted here).
  useStatusLog();

  if (promptAt) {
    return (
      <div role="alertdialog" aria-label="Still there?" style={strip}>
        <strong>Still there?</strong>
        <span style={{ flex: 1 }}>
          You are Available but the console has been idle. You will be set to Offline in {secondsLeft} seconds so callers are not kept waiting.
        </span>
        <button type="button" style={button} onClick={imHere} autoFocus>I&rsquo;m here</button>
      </div>
    );
  }
  if (notice) {
    return (
      <div role="status" style={strip}>
        <strong>You are Offline.</strong>
        <span style={{ flex: 1 }}>{NOTICE_TEXT[notice.reason] || NOTICE_TEXT.idle}</span>
        <button type="button" style={button} onClick={goAvailable}>Go Available</button>
        <button type="button" style={quiet} onClick={dismissNotice}>Stay Offline</button>
      </div>
    );
  }
  return null;
}
